module.exports = __webpack_public_path__ + "static/media/Vintage 57 Guitar Match off VR.c5922a4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Vintage 57 Guitar Match off VR.mp3
// module id = TFfs
// module chunks = 12